export const randomColor = (): string => `hsl(${Math.floor(360 * Math.random())},70%,20%)`;
